import { COLORS } from '.'

/**
 * Constants
 */
export const borderRadius2 = '2px' // WEB ONLY!
export const borderRadius4 = '4px'
export const borderRadius8 = '8px'
export const borderRadius12 = '12px'
export const borderRadius16 = '16px'
export const borderRadius40 = '40px'
/**
 * Round to a pill or full circle. The exact value here is arbitrary and might change.
 * It just needs to be greater than the element's width and height.
 */
export const borderRadiusFull = '200px'

/**
 * Styles
 */
export const styleSolid = 'solid'

/**
 * Special-case borders
 */
export const activeLineBorder = `1px ${styleSolid} ${COLORS.blue50}`
export const lineBorder = `1px ${styleSolid} ${COLORS.grey30}`

/**
 * Shadows
 */
export const smallDropShadow = '0px 3px 6px rgba(0, 0, 0, 0.23)'
export const tinyDropShadow = '0px 1px 3px 0px rgba(0, 0, 0, .33)'
// touch screen
export const shadowBig = '0px 3px 6px rgba(0,0,0,0.23)'
export const shadowSmall = '0px 0px 40px rgba(0,0,0,0.4)'
